import { gsap, lenis } from '../../global/gsap';

const initProjectSplash = (section) => {
    const motif = section.querySelector('.js-motif');

    if (!motif) {
        gsap.to(section, {
            autoAlpha: 0
        });
    } else {
        gsap.set(motif, {
            yPercent: 10
        });

        const splashTl = gsap.timeline({
            defaults: {
                ease: 'power3.out',
                duration: 0.5
            },
            onStart: () => {
                window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
                document.body.classList.add('stop-scrolling');
                lenis.stop();
            },
            onComplete: () => {
                document.body.classList.remove('stop-scrolling');
                lenis.start();
            }
        });

        splashTl.to(motif, {
            autoAlpha: 1,
            yPercent: 0,
            delay: 0.25
        }).to(motif, {
            scale: 0.75,
            opacity: 0,
            delay: 1
        }).to(section, {
            scaleY: 0,
            duration: 0.75,
            ease: 'power4.out'
        });
    }
};

export default initProjectSplash;
